import styled, { css } from "styled-components"

import { PageItem as _PageItem } from "./components/PageItem"

export const Container = styled.nav``

const itemStyle = css`
  color: inherit;
  &[aria-current="true"] {
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
  }
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`
export const PageItem = styled(_PageItem)`
  ${itemStyle}
`
export const List = styled.ul`
  list-style-type: none;
  padding-left: 0;
  display: flex;
  width: 100%;
  justify-content: space-between;
  color: inherit;
  li {
    color: inherit;
    display: inline-block;
  }
`
